"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _find = _interopRequireDefault(require("lodash/fp/find"));

var _pipe = _interopRequireDefault(require("lodash/fp/pipe"));

var _sortBy = _interopRequireDefault(require("lodash/fp/sortBy"));

var getDeliveryInfo = function getDeliveryInfo(stock) {
  var available = stock.available,
      detail = stock.detail;

  if (available) {
    var _ref = (0, _pipe.default)((0, _sortBy.default)(['warehouse']), (0, _find.default)(function (s) {
      return s.quantity > 0;
    }))(detail || []) || {},
        _ref$quantity = _ref.quantity,
        quantity = _ref$quantity === void 0 ? 0 : _ref$quantity,
        warehouse = _ref.warehouse;

    return {
      available: available,
      warehouse: warehouse,
      quantity: quantity,
      timing: undefined
    };
  }

  var primaryWH = (detail || []).find(function (s) {
    return s.warehouse === '1';
  });

  if (primaryWH && primaryWH.state === 'to-order' && primaryWH.timing && Array.isArray(primaryWH.timing)) {
    return {
      available: available,
      warehouse: 'external',
      quantity: 0,
      timing: primaryWH.timing
    };
  }

  return {
    available: available,
    warehouse: undefined,
    quantity: 0,
    timing: undefined
  };
};

var _default = getDeliveryInfo;
exports.default = _default;